import { getAccessToken } from './auth';
import axios from 'axios';

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://staker-200619.appspot.com' : 'http://localhost:1337';
axios.defaults.headers.common['Authorization'] = `Bearer ${getAccessToken()}`;

const getFirebaseToken = async accessToken => {
  // Set default auth token on sign in
  axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

  return axios.get('/auth/firebase');
};

const fetchUsers = async () => {
  return axios.get('/users');
};

const updateUserBalance = async (balanceChange, userId) => {

  return axios.post('/user/updateBalance', { balanceChange, userId });
};

export default {
  fetchUsers,
  getFirebaseToken,
  updateUserBalance
};



// WEBPACK FOOTER //
// ./src/utils/api.js